import { useState } from 'react';
import { DeleteIcon, BreezeRegenerateIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export const ViewActionButton = ({
  onClick,
  tabId,
  tooltip,
  disabled,
  icon
}) => {
  const [use, setUse] = useState('transparent');
  const ariaLabel = icon === 'delete' ? I18n.text('viewsManagement.modals.generateView.deleteView') : I18n.text('viewsManagement.modals.generateView.saveView');
  return /*#__PURE__*/_jsx(Flex, {
    onMouseEnter: () => setUse('tertiary-light'),
    onMouseLeave: () => setUse('transparent'),
    children: /*#__PURE__*/_jsx(IconButton, {
      tooltip: tooltip,
      size: "xs",
      use: use,
      disabled: disabled,
      "data-test-id": `ai-${icon}-${tabId}`,
      "aria-label": ariaLabel,
      onClick: e => {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        onClick();
      },
      children: icon === 'delete' ? /*#__PURE__*/_jsx(DeleteIcon, {
        size: "100",
        color: "icon-primary-default"
      }) : /*#__PURE__*/_jsx(BreezeRegenerateIcon, {
        size: "100",
        color: "icon-primary-default"
      })
    })
  });
};